import { render, staticRenderFns } from "./confirmBad.vue?vue&type=template&id=62bfa633&scoped=true"
import script from "./confirmBad.vue?vue&type=script&lang=js"
export * from "./confirmBad.vue?vue&type=script&lang=js"
import style0 from "./confirmBad.vue?vue&type=style&index=0&id=62bfa633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bfa633",
  null
  
)

export default component.exports